import { Box, Paper, Table, TableBody, TableContainer, TableHead } from "@mui/material";


function OrderTable ({headerRow, rows}) {
  return (
    <Box>
      <TableContainer component={Paper} sx={{maxWidth: "calc(100vw - 100px)", overflowX:"scroll"}}>
        <Table>
          <TableHead >
            {headerRow}
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default OrderTable;

